import { MANAGEMENT_HS_EXCLUSION_TITLE, MANAGEMENT_HS_EXPORT_TITLE } from "./hubspotKeys";
import {
    MANAGEMENT_DYNAMICS_INTEGRATION_NAME,
    MANAGEMENT_ENRICHMENT_TITLE,
    MANAGEMENT_EXPORT_TO_CRM_TITLE,
    MANAGEMENT_HS_INTEGRATION_NAME,
    MANAGEMENT_IMPORT_FROM_CRM_TITLE,
    MANAGEMENT_LAST_SYNCED_TEXT,
    MANAGEMENT_SF_EXCLUSION_TITLE,
    MANAGEMENT_SF_EXPORT_TITLE,
    MANAGEMENT_SF_INTEGRATION_NAME,
} from "./managementKeys";
import {
    MANAGEMENT_INTEGRATION_DESCRIPTION,
    MANAGEMENT_SF_INTEGRATION_INFO_POINT_1,
    MANAGEMENT_SF_INTEGRATION_INFO_POINT_2,
} from "./salesforceKeys";

export const MANAGEMENT_BODY_TEXTS = {
    salesforce: {
        name: MANAGEMENT_SF_INTEGRATION_NAME,
        exclusion: MANAGEMENT_SF_EXCLUSION_TITLE,
        export: MANAGEMENT_SF_EXPORT_TITLE,
        exportToCRM: MANAGEMENT_EXPORT_TO_CRM_TITLE,
        importFromCRM: MANAGEMENT_IMPORT_FROM_CRM_TITLE,
        description: MANAGEMENT_INTEGRATION_DESCRIPTION,
        point1: MANAGEMENT_SF_INTEGRATION_INFO_POINT_1,
        point2: MANAGEMENT_SF_INTEGRATION_INFO_POINT_2,
        syncText: MANAGEMENT_LAST_SYNCED_TEXT,
        enrichment: MANAGEMENT_ENRICHMENT_TITLE,
    },
    hubspot: {
        name: MANAGEMENT_HS_INTEGRATION_NAME,
        exclusion: MANAGEMENT_HS_EXCLUSION_TITLE,
        export: MANAGEMENT_HS_EXPORT_TITLE,
        exportToCRM: MANAGEMENT_EXPORT_TO_CRM_TITLE,
        importFromCRM: MANAGEMENT_IMPORT_FROM_CRM_TITLE,
        description: MANAGEMENT_INTEGRATION_DESCRIPTION,
        point1: MANAGEMENT_SF_INTEGRATION_INFO_POINT_1,
        point2: MANAGEMENT_SF_INTEGRATION_INFO_POINT_2,
        syncText: MANAGEMENT_LAST_SYNCED_TEXT,
        enrichment: MANAGEMENT_ENRICHMENT_TITLE,
    },
    dynamics: {
        name: MANAGEMENT_DYNAMICS_INTEGRATION_NAME,
        exclusion: MANAGEMENT_SF_EXCLUSION_TITLE,
        export: MANAGEMENT_SF_EXPORT_TITLE,
        exportToCRM: MANAGEMENT_EXPORT_TO_CRM_TITLE,
        importFromCRM: MANAGEMENT_IMPORT_FROM_CRM_TITLE,
        description: MANAGEMENT_INTEGRATION_DESCRIPTION,
        point1: MANAGEMENT_SF_INTEGRATION_INFO_POINT_1,
        point2: MANAGEMENT_SF_INTEGRATION_INFO_POINT_2,
        syncText: MANAGEMENT_LAST_SYNCED_TEXT,
        enrichment: MANAGEMENT_ENRICHMENT_TITLE,
    },
};

export const MANAGEMENT_MANAGE_EXPORT_TITLE = "si.management.manage_export.title";

export const MANAGEMENT_MANAGE_EXPORT_SALESFORCE_SUB_TITLE = "si.management.manage_export.salesforce.sub_title";
export const MANAGEMENT_MANAGE_EXPORT_HUBSPOT_SUB_TITLE = "si.management.manage_export.hubspot.sub_title";
export const MANAGEMENT_MANAGE_EXPORT_DYNAMICS_SUB_TITLE = "si.management.manage_export.dynamics.sub_title";

export const MISSING_FIELDS_IN_ACCOUNTS = {
    salesforce: "si.management.manage_export.missing_required_fields.salesforce.in_accounts",
    hubspot: "si.management.manage_export.missing_required_fields.hubspot.in_accounts",
};

export const MISSING_FIELDS_IN_CONTACTS = "si.management.manage_export.missing_required_fields.in_contacts";

export const MISSING_FIELDS_IN_LEADS = "si.management.manage_export.missing_required_fields.in_leads";

export const MISSING_FIELDS_MESSAGE = "si.management.manage_export.missing_required_fields";
